/**
 * web-account-pages D2: the website page a notice's door opens. The door is built for the Mini App
 * (`clientDoorOf` in @telify/shared: a booking `/booking-hub/booking/:bookingId`, a waiting form
 * `/form-request/:ctaToken`, an open event invite `/book/event/:calendarEventId`, an offering
 * `/book/service/:serviceId`); the panel maps it to the website's own page:
 * - booking: the booking page `/account/bookings/:bookingId`;
 * - form: the website form page `/form-request/:requestToken` (the same path shape);
 * - offering: the service page `/services/:serviceId` (the name part is cosmetic); a shared event,
 *   which has no service page, the Events page `/events`;
 * - invite: none, the website has no invites yet.
 * A null door (a consumed form, a subject that is gone) and a path that is not its kind's shape
 * show no action.
 */
import type { ClientDoor } from '@telify/shared';

const SEGMENT = '([A-Za-z0-9_-]{1,128})';
const BOOKING_PATH = new RegExp(`^/booking-hub/booking/${SEGMENT}$`);
const FORM_PATH = new RegExp(`^/form-request/${SEGMENT}$`);
const OFFERING_PATH = new RegExp(`^/book/service/${SEGMENT}$`);

/** The website page a door opens, or null for no action. */
export function webDoorHref(door: ClientDoor | null): string | null {
  if (!door) return null;
  switch (door.kind) {
    case 'booking': {
      const id = BOOKING_PATH.exec(door.path)?.[1];
      return id ? `/account/bookings/${id}` : null;
    }
    case 'form': {
      const token = FORM_PATH.exec(door.path)?.[1];
      return token ? `/form-request/${token}` : null;
    }
    case 'offering': {
      if (door.sharedEvent) return door.path === '/book' ? '/events' : null;
      const id = OFFERING_PATH.exec(door.path)?.[1];
      return id ? `/services/${id}` : null;
    }
    case 'invite':
      return null;
  }
}
